// extracted by mini-css-extract-plugin
export default {"header":"FormacionHeader_header__6FFkO","headerIcon":"FormacionHeader_headerIcon__nW7OA"};